/* @flow */

import React from 'react';
import {useHistory} from 'react-router-dom';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import ButtonComponent from 'components/buttons/button';
import IntlMessageComponent from 'components/formatters/intlMessage';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';

import {PROTECTED_DEBTOR_DASHBOARD} from 'constants/pageRoutes';

export default function DebtorRegisterLeadTab3Component() {
  const history = useHistory();

  const onButtonClick = () => {
    history.push(PROTECTED_DEBTOR_DASHBOARD);
  }

  return (
    <React.Fragment>
      <PageSubTitleViewComponent id="debtor.registerLead.tab3.title" />

      <Typography variant="body1" gutterBottom>
        <IntlMessageComponent id="debtor.registerLead.tab3.text" />
      </Typography>

      <Box mt={5}>
        <ButtonComponent
          color="primary"
          variant="contained"
          onClick={onButtonClick}
        ><IntlMessageComponent id="debtor.registerLead.tab3.button" /></ButtonComponent>
      </Box>
    </React.Fragment>
  );
}
